import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Auth } from '@freelancer/auth';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: Auth) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.authState.pipe(
      map(auth => {
        if (!auth) {
          this.router.navigate(['/login'], {
            queryParams: {
              next: state.url,
            },
          });
          return false;
        }
        return true;
      }),
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts